// Called by Google Maps API once loaded (via &callback=initMap in the script URL)
function initMap() {
    if (!document.getElementById('locations-map')) return;
    // Smile Solutions Melbourne location
    var smileSolutionsLocation = {
        lat: -37.81525,
        lng: 144.96628
    };

    // Create the map
    var map = new google.maps.Map(document.getElementById('locations-map'), {
        zoom: 19,
        center: smileSolutionsLocation,
        mapTypeControl: false,
        streetViewControl: false,
        fullscreenControl: true,
        zoomControl: false,
        minZoom: 10,
        maxZoom: 18,
        keyboardShortcuts: false,
        disableDefaultUI: false,
        clickableIcons: false,
        styles: [
            {
                "elementType": "geometry",
                "stylers": [
                    {
                        "color": "#f5f5f5"
                    }
                ]
            },
            {
                "elementType": "labels.icon",
                "stylers": [
                    {
                        "visibility": "off"
                    }
                ]
            },
            {
                "elementType": "labels.text.fill",
                "stylers": [
                    {
                        "color": "#616161"
                    }
                ]
            },
            {
                "elementType": "labels.text.stroke",
                "stylers": [
                    {
                        "color": "#f5f5f5"
                    }
                ]
            },
            {
                "featureType": "administrative.land_parcel",
                "elementType": "labels.text.fill",
                "stylers": [
                    {
                        "color": "#bdbdbd"
                    }
                ]
            },
            {
                "featureType": "poi",
                "elementType": "geometry",
                "stylers": [
                    {
                        "color": "#eeeeee"
                    }
                ]
            },
            {
                "featureType": "poi",
                "elementType": "labels.text.fill",
                "stylers": [
                    {
                        "color": "#757575"
                    }
                ]
            },
            {
                "featureType": "poi.park",
                "elementType": "geometry",
                "stylers": [
                    {
                        "color": "#e5e5e5"
                    }
                ]
            },
            {
                "featureType": "poi.park",
                "elementType": "labels.text.fill",
                "stylers": [
                    {
                        "color": "#9e9e9e"
                    }
                ]
            },
            {
                "featureType": "road",
                "elementType": "geometry",
                "stylers": [
                    {
                        "color": "#eeeeee"
                    }
                ]
            },
            {
                "featureType": "road.arterial",
                "elementType": "labels.text.fill",
                "stylers": [
                    {
                        "color": "#757575"
                    }
                ]
            },
            {
                "featureType": "road.highway",
                "elementType": "geometry",
                "stylers": [
                    {
                        "color": "#dadada"
                    }
                ]
            },
            {
                "featureType": "road.highway",
                "elementType": "labels.text.fill",
                "stylers": [
                    {
                        "color": "#616161"
                    }
                ]
            },
            {
                "featureType": "road.local",
                "elementType": "labels.text.fill",
                "stylers": [
                    {
                        "color": "#9e9e9e"
                    }
                ]
            },
            {
                "featureType": "transit.line",
                "elementType": "geometry",
                "stylers": [
                    {
                        "color": "#e5e5e5"
                    }
                ]
            },
            {
                "featureType": "transit.station",
                "elementType": "geometry",
                "stylers": [
                    {
                        "color": "#eeeeee"
                    }
                ]
            },
            {
                "featureType": "water",
                "elementType": "geometry",
                "stylers": [
                    {
                        "color": "#c9c9c9"
                    }
                ]
            },
            {
                "featureType": "water",
                "elementType": "labels.text.fill",
                "stylers": [
                    {
                        "color": "#9e9e9e"
                    }
                ]
            },
            {
                "featureType": "landscape.man_made",
                "elementType": "geometry.stroke",
                "stylers": [
                    {
                        "color": "#d4d4d4"
                    },
                    {
                        "weight": 1
                    }
                ]
            },
            {
                "featureType": "landscape.man_made",
                "elementType": "geometry.fill",
                "stylers": [
                    {
                        "color": "#ffffff"
                    }
                ]
            }
        ]
    });

    // Add gray marker for Smile Solutions Melbourne
    var marker = new google.maps.Marker({
        position: smileSolutionsLocation,
        map: map,
        title: 'Smile Solutions Melbourne',
        animation: google.maps.Animation.DROP,
        icon: 'data:image/svg+xml;charset=UTF-8,' + encodeURIComponent(`
            <svg width="27" height="43" viewBox="0 0 27 43" xmlns="http://www.w3.org/2000/svg">
                <path d="M13.5 0C6.044 0 0 6.044 0 13.5C0 18.5 4 25 8 30C10 32.5 12 36 13.5 43C15 36 17 32.5 19 30C23 25 27 18.5 27 13.5C27 6.044 20.956 0 13.5 0Z" fill="#C0C0C0" stroke="#333333" stroke-width="1"/>
                <circle cx="13.5" cy="13.5" r="4.5" fill="#666666"/>
            </svg>
        `)
    });

    // Create custom label overlay
    function CustomLabel(options) {
        this.position = options.position;
        this.content = options.content;
        this.map = options.map;
        this.setMap(this.map);
    }

    CustomLabel.prototype = new google.maps.OverlayView();

    CustomLabel.prototype.onAdd = function() {
        var div = document.createElement('div');
        div.style.position = 'absolute';
        div.style.fontSize = '13px';
        div.style.lineHeight = '1';
        div.style.fontWeight = '600';
        div.style.color = '#333333';
        div.style.textShadow = '1px 1px 1px rgba(255,255,255,0.8)';
        div.innerHTML = this.content;
        
        this.div = div;
        var panes = this.getPanes();
        panes.overlayLayer.appendChild(div);
    };

    CustomLabel.prototype.draw = function() {
        var projection = this.getProjection();
        var position = projection.fromLatLngToDivPixel(this.position);
        
        var div = this.div;
        div.style.left = (position.x + 20) + 'px'; // 20px to the right of marker
        div.style.top = (position.y - 35) + 'px';  // Slightly above center
    };

    CustomLabel.prototype.onRemove = function() {
        this.div.parentNode.removeChild(this.div);
        this.div = null;
    };

    // Add the custom label
    var customLabel = new CustomLabel({
        position: smileSolutionsLocation,
        content: 'Smile Solutions -<br>Dentist Melbourne',
        map: map
    });
}
